import { render, staticRenderFns } from "./ShootsPerBrief.vue?vue&type=template&id=02420ad0"
import script from "./ShootsPerBrief.vue?vue&type=script&lang=js"
export * from "./ShootsPerBrief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports